<template>
  <div class="wrapper" style="background: none">
    <dash-header></dash-header>
    <sidebar></sidebar>
    <div class="content-wrapper p-3" style="background: none">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-12">
              <h1 class="m-2" style="font-weight: bold; font-size: 35px">
                Introduction Broker
              </h1>
              <div class="row">
                <div class="col-lg-12">
                  <div class="card card__advert p-2">
                    <div class="card-advert__body">
                      <div class="col-lg-8">
                        <h2 class="card-advert__text">
                          Invite More Friends to Get Points
                        </h2>
                        <p class="card-advert__solution">
                          Invite friends to join in trading, by sending your
                          referral code
                        </p>
                      </div>
                      <div class="col-lg-2">
                        <img
                          src="../assets/frame_advert1.png"
                          class="card-advert__frame"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="card card-ib-status p-3">
                    <div class="card-ib-status__pcode">
                      <p class="card-ib-status__title">Preferral code :</p>
                      <p class="card-ib-status__code">
                        aXrstew2
                        <a href="/" class="card-ib-status__text-copy">Copy</a>
                      </p>
                    </div>
                    <i
                      class="fas fa-wallet fa-7x"
                      style="
                        color: #565555;
                        margin-left: 10px;
                        margin-top: 20px;
                      "
                    ></i>
                    <div class="ib-status__text-body">
                      <h2 class="ib-status__heading">
                        Current commision balance
                      </h2>
                      <p class="ib-status__nominal">$2.000.000</p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-3">
                    <div class="card ib-status__card p-3">
                      <h2 class="ib-status__text-card">Investors Invited</h2>
                      <h3 class="ib-status__numbers">12</h3>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="card ib-status__card p-3">
                      <h2 class="ib-status__text-card">Deposit Collect</h2>
                      <h3 class="ib-status__numbers">$ 13.500</h3>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="card ib-status__card p-3">
                      <h2 class="ib-status__text-card">Trading Profit</h2>
                      <h3 class="ib-status__numbers">$ 15.500</h3>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="card ib-status__card p-3">
                      <h2 class="ib-status__text-card">Reward Points</h2>
                      <h3 class="ib-status__numbers">14</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="content"></section>
    </div>
    <dash-footer></dash-footer>
  </div>
</template>
<script>
import DashHeader from "../layouts/Header.vue";
import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import { dragscroll } from "vue-dragscroll";
export default {
  directives: {
    dragscroll,
  },
  name: "Databank",
  components: {
    DashHeader,
    DashFooter,
    Sidebar,
  },
};
</script>
<style>
.ib-status__card {
  border-radius: 15px;
}
.ib-status__text-card {
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
  font-weight: bold;
  font-size: 20px;
}
.ib-status__numbers {
  font-weight: bold;
  margin-left: 20px;
  font-size: 40px;
}
.ib-status__text-body {
  display: flex;
}
.ib-status__heading {
  font-weight: bold;
  font-size: 30px;
  margin-left: 150px;
  margin-top: -90px;
}
.ib-status__nominal {
  margin-top: -50px;
  margin-left: -435px;
  font-weight: bold;
  font-size: 30px;
}
.card-advert__text {
  text-align: left;
  margin-left: 140px;
  font-size: 20px;
  font-weight: 600;
  margin-top: 20px;
}
.card-advert__body {
  display: flex;
}
.card-advert__frame {
  width: 284px;
  height: 135px;
  object-fit: cover;
}
.heading__title {
  color: rgba(0, 0, 0, 0.6);
  font-weight: bold;
  font-size: 26px;
  margin-left: 7px;
}
.card__advert {
  border-radius: 15px;
}
.card-ib-status {
  border-radius: 15px;
}
.card-ib-status__pcode {
  text-align: center;
  position: relative;
}
.card-ib-status__title {
  text-align: left;
}
.card-ib-status__text-copy {
  font-weight: bold;
  margin-left: 10px;
  text-decoration: none;
  position: absolute;
}

.card-advert__solution {
  font-weight: bold;
  text-align: left;
  margin-left: 140px;
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
  color: rgba(0, 0, 0, 0.5);
}
.card-ib-status__code {
  font-weight: bold;
  position: absolute;
  right: 950px;
  top: 0;
}

</style>